/*
 * Delivery type when we
 * choose delivery during donation process
 */

import { ImageObject } from "../../donate-page/item-images/item-images.hook"
import { SelectNonprofitProps } from "../../donate-page/donate.models"
import { Form } from "../../../hooks/use-form/use-form.types"
import { ItemState } from "../../../models/item-details"

export const DeliveryType = {
  Shipping: 'shipping',
  LocalPickup: 'local-pickup',
  Both: 'both',
}

export enum KindImageEnum {
  existing = 1,
  new = 2,
}

export type DraftImageItemType = {
  newImageGuid?: string | number
  existingImageId?: string | number
  kind: KindImageEnum
}

export type DraftDataType = {
  name: string
  description: string
  price: number
  condition: string
  delivery: string
  weight: number
  height: number
  length: number
  width: number
  images: DraftImageItemType[] | []
  nonprofitId?: number
}

type DraftHandlersType = {
  setImages: (value: ImageObject[]) => void
  getSelectedData: () => void
  submitItem: (value: Form, saveDraft?: boolean) => void
}

type DraftInitialImages = {
  initialImages: string[]
}

type DraftState = {
  isDirtyDraft: boolean
  setIsDirtyDraft: (value: boolean) => void
  closeDraftMode: () => void
  editItemState?: ItemState
  loading: boolean
}

export type DraftProps = DraftDataType &
  DraftHandlersType &
  DraftInitialImages &
  SelectNonprofitProps &
  DraftState

export const initialValues: DraftDataType = {
  name: '',
  description: '',
  price: 0,
  condition: '',
  delivery: DeliveryType.Shipping,
  weight: 0,
  height: 0,
  length: 0,
  width: 0,
  images: [],
  nonprofitId: 0,
}
